import {useMutation} from '@apollo/client';
import {
    ABANDON_CUSTOMER_COMPLAINT_APPEAL,
    AbandonCustomerComplaintAppealResponse,
    AbandonCustomerComplaintAppealVariables,
    ACKNOWLEDGE_CUSTOMER_COMPLAINT,
    AcknowledgeCustomerComplaintResponse,
    AcknowledgeCustomerComplaintVariables,
    SUBMIT_CUSTOMER_COMPLAINT_APPEAL,
    SubmitCustomerComplaintAppealResponse,
    SubmitCustomerComplaintAppealVariables,
} from '../graphql/mutations/complaintMutations';

export function useSubmitCustomerComplaintAppeal() {
    return useMutation<SubmitCustomerComplaintAppealResponse, SubmitCustomerComplaintAppealVariables>(
        SUBMIT_CUSTOMER_COMPLAINT_APPEAL
    );
}

export function useAcknowledgeCustomerComplaint() {
    return useMutation<AcknowledgeCustomerComplaintResponse, AcknowledgeCustomerComplaintVariables>(
        ACKNOWLEDGE_CUSTOMER_COMPLAINT
    );
}

export function useAbandonCustomerComplaintAppeal() {
    return useMutation<AbandonCustomerComplaintAppealResponse, AbandonCustomerComplaintAppealVariables>(
        ABANDON_CUSTOMER_COMPLAINT_APPEAL
    );
}
